import Auth0ProviderWithHistory from './Auth0ProviderWithHistory';

export default Auth0ProviderWithHistory;